import { Navigate } from '@sorare/routing';
import { LoadingIndicator } from '@sorare/core/src/atoms/loader/LoadingIndicator';
import { MobileAppBottomPortalReceiver } from '@sorare/core/src/components/navigation/AppNavigation';
import { ANY_SPORT_MARKET_SHOP_INSTANT_BUY } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useFlashSalesEnabled } from '@sorare/core/src/hooks/market/useMatchdayPicksTab';
import { useIsMobileApp } from '@sorare/core/src/hooks/useIsMobileApp';
import { PageTemplate } from '@sorare/marketplace/src/components/market/PageTemplate';
import { MatchdayPicksSearch } from '@sorare/marketplace/src/components/matchdayPicks/MatchdayPicksSearch';

const MatchdayPicksPage = () => {
  const { sport, generateSportContextPath } = useSportContext();
  const { isIosApp } = useIsMobileApp();

  const { enabled, resolving } = useFlashSalesEnabled({ sport });

  if (!resolving && !enabled) {
    return (
      <Navigate
        to={generateSportContextPath(ANY_SPORT_MARKET_SHOP_INSTANT_BUY)}
        replace
      />
    );
  }

  return (
    <>
      <PageTemplate showBack>
        {resolving ? (
          <LoadingIndicator fullHeight />
        ) : (
          <MatchdayPicksSearch sport={sport} />
        )}
      </PageTemplate>

      {!!isIosApp && (
        <MobileAppBottomPortalReceiver id="above-bottom-bar-portal" />
      )}
    </>
  );
};

export default MatchdayPicksPage;
